function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = _object_without_properties_loose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function _tagged_template_literal(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _tagged_template_literal([
        "\n  background: transparent;\n  border-radius: ",
        ";\n  border: 2px solid #ffffff;\n  color: #ffffff;\n  font-size: 12px;\n  font-weight: bold;\n  height: 32px;\n  line-height: 13px;\n  text-transform: ",
        ";\n  width: 65px;\n\n  &:hover {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _tagged_template_literal([
        ""
    ]);
    _templateObject1 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _tagged_template_literal([
        "\n  font-weight: bold;\n  font-size: 16px;\n  line-height: 120%;\n  color: #ffffff;\n  text-shadow: 0px 2px 4px rgba(152, 163, 173, 0.36);\n  width: 100%;\n  word-break: break-word;\n"
    ]);
    _templateObject2 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = _tagged_template_literal([
        "\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding-bottom: 24px;\n  max-width: 232px;\n"
    ]);
    _templateObject3 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = _tagged_template_literal([
        "\n      margin-right: 0;\n      scroll-margin: 0;\n    "
    ]);
    _templateObject4 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = _tagged_template_literal([
        "\n        margin-right: 0;\n      "
    ]);
    _templateObject5 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = _tagged_template_literal([
        "\n        margin-right: 0;\n      "
    ]);
    _templateObject6 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = _tagged_template_literal([
        "\n  border-radius: 20px;\n  position: relative;\n  width: 100%;\n  min-width: 310px; /* this is our initial multi offer card size */\n  margin-right: 14px;\n  scroll-margin: 14px;\n  scroll-snap-align: start;\n  scroll-snap-stop: normal;\n\n  ",
        "\n\n  /* only turn off the last margin if we have more cards than our row size */\n  &.last-card {\n    /* give us enough room to let our box shadows end */\n    &:after {\n      content: '';\n      display: block;\n      background: transparent;\n      position: absolute;\n      right: -14px;\n      top: 0px;\n      bottom: 0;\n      left: 100%;\n    }\n  }\n\n  /* up until 600px.... */\n  @media (max-width: 600px) {\n    ",
        "\n\n    ",
        "\n  }\n\n  /* over 600px.... */\n  @media (min-width: 600px) {\n    /* allows us to fit 2 across */\n    min-width: 260.25px; /* allows for 14px of space in between */\n    /* REMOVE NEXT LINE IF WE EVER WANT TO STOP HAVING LOADS OF EXTRA SPACE */\n    width: 260.25px;\n\n    &.last-card {\n      /* give us enough room to let our box shadows end */\n      &:after {\n        right: ",
        ";\n      }\n    }\n  }\n\n  /* over 750.5px.... */\n  @media (min-width: 750.5px) {\n    /* allows us to fit 3 across */\n    min-width: 240.833px; /* allows for 14px of space in between */\n    /* REMOVE NEXT LINE IF WE EVER WANT TO STOP HAVING LOADS OF EXTRA SPACE */\n    width: 240.833px;\n  }\n\n  /* over 966.5px.... */\n  @media (min-width: 966.5px) {\n    /* allows us to fit 3 across */\n    min-width: 312.833px; /* allows for 14px of space in between */\n    /* REMOVE NEXT LINE IF WE EVER WANT TO STOP HAVING LOADS OF EXTRA SPACE */\n    width: 312.833px;\n  }\n\n  /* over 1187px.... */\n  @media (min-width: 1187px) {\n    /* allows us to fit 3 across */\n    min-width: 377.5px; /* this is our magic number from figma, but will allow for more space (27.25px) */\n    /* REMOVE NEXT LINE IF WE EVER WANT TO STOP HAVING LOADS OF EXTRA SPACE */\n    width: 377.5px;\n    margin-right: 27px;\n    /* turn on the gradients! */\n    box-shadow: 0px 4px 14px rgba(0, 0, 0, 0.25);\n\n    ",
        "\n\n    &.last-card {\n      /* give us enough room to let our box shadows end*/\n      &:after {\n        content: '';\n        display: block;\n        background: transparent;\n        position: absolute;\n        right: ",
        ";\n        top: 0px;\n        bottom: 0;\n        left: 100%;\n      }\n    }\n  }\n"
    ]);
    _templateObject7 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = _tagged_template_literal([
        "\n  position: relative;\n  padding-bottom: 50%;\n  border-radius: 20px;\n  /* over 600px.... */\n  @media (min-width: 600px) {\n    /* squeezing two cards is so hard here at 2:1 or narrow ratio,\n       ima bump this up so that we can fit 2 lines of text */\n    padding-bottom: 58%;\n  }\n\n  /* over 750.5px.... */\n  @media (min-width: 750.5px) {\n    padding-bottom: 63%;\n  }\n\n  /* over 966.5px.... */\n  @media (min-width: 966.5px) {\n    padding-bottom: 50%;\n  }\n\n  /* over 1187px.... */\n  @media (min-width: 1187px) {\n    padding-bottom: 43.77%;\n  }\n"
    ]);
    _templateObject8 = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = _tagged_template_literal([
        "\n  padding: 29px;\n  background: ",
        ";\n  background-position: center left;\n  background-size: cover;\n  border-radius: ",
        ";\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n\n  &:hover {\n    cursor: pointer;\n    button {\n      border: 2px solid #fff;\n      background-color: #fff;\n      color: #242526;\n    }\n  }\n"
    ]);
    _templateObject9 = function _templateObject() {
        return data;
    };
    return data;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import _ from 'lodash';
import React from 'react';
import styled, { css } from 'styled-components';
import Truncate from 'react-truncate';
import { observer } from 'mobx-react-lite';
import { DEFAULT_SPECIALS_CARD_IMG } from 'shared/constants';
import { replaceAWSSourceWithImgix } from 'shared/helpers/imgix';
import { EmbeddedExternalLink, Link } from 'components/core';
import useUI from 'hooks/use-ui';
import usePaths from 'hooks/use-paths';
function OffersCarouselCard(_param) {
    var _param_className = _param.className, className = _param_className === void 0 ? "offers" : _param_className, displayImage = _param.displayImage, displayName = _param.displayName, _param_enableRightMargin = _param.enableRightMargin, enableRightMargin = _param_enableRightMargin === void 0 ? true : _param_enableRightMargin, isSingularCard = _param.isSingularCard, specialId = _param.specialId, specialType = _param.specialType, _param_isUsingGapSpacing = _param.isUsingGapSpacing, isUsingGapSpacing = _param_isUsingGapSpacing === void 0 ? false : _param_isUsingGapSpacing, props = _object_without_properties(_param, [
        "className",
        "displayImage",
        "displayName",
        "enableRightMargin",
        "isSingularCard",
        "specialId",
        "specialType",
        "isUsingGapSpacing"
    ]);
    return /*#__PURE__*/ _jsx(AspectRatioOuter, {
        className: className,
        enableRightMargin: enableRightMargin,
        isSingularCard: isSingularCard,
        $isUsingGapSpacing: isUsingGapSpacing,
        children: /*#__PURE__*/ _jsx(AspectRatioInner, {
            children: /*#__PURE__*/ _jsx(LinkComponent, {
                specialId: specialId,
                specialType: specialType,
                children: /*#__PURE__*/ _jsxs(OffersCardContainer, _object_spread_props(_object_spread({
                    className: className,
                    "data-cy": "offers-carousel-card",
                    "data-test": "offers-carousel-card",
                    imageUrl: replaceAWSSourceWithImgix(displayImage) || DEFAULT_SPECIALS_CARD_IMG,
                    isSingularCard: isSingularCard
                }, props), {
                    children: [
                        /*#__PURE__*/ _jsx(TextContainer, {
                            children: /*#__PURE__*/ _jsx(Title, {
                                children: /*#__PURE__*/ _jsx(Truncate, {
                                    lines: 2,
                                    children: displayName
                                })
                            })
                        }),
                        /*#__PURE__*/ _jsx(ActionsContainer, {
                            children: /*#__PURE__*/ _jsx(ShopButton, {
                                children: "Shop"
                            })
                        })
                    ]
                }))
            })
        })
    });
}
var LinkComponent = observer(function(param) {
    var children = param.children, specialId = param.specialId, specialType = param.specialType;
    var isEmbeddedCarousel = useUI().isEmbeddedCarousel;
    var href = usePaths({
        specials: true
    }).href;
    var routeType = getSpecialType(specialType);
    var offerUrl = "".concat(href, "/").concat(routeType, "/").concat(specialId);
    if (isEmbeddedCarousel) {
        return /*#__PURE__*/ _jsx(EmbeddedExternalLink, {
            href: offerUrl,
            children: children
        });
    }
    return /*#__PURE__*/ _jsx(Link, {
        href: offerUrl,
        children: children
    });
});
var getSpecialType = function(specialType) {
    var isSale = specialType === 'sale' || specialType === 'SALE';
    return isSale ? 'sale' : 'offer';
};
var ShopButton = styled.button(_templateObject(), function(param) {
    var theme = param.theme;
    var _theme_customized_radius, _theme_customized;
    var _theme_customized_radius_buttons;
    return (_theme_customized_radius_buttons = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_radius = _theme_customized.radius) === null || _theme_customized_radius === void 0 ? void 0 : _theme_customized_radius.buttons) !== null && _theme_customized_radius_buttons !== void 0 ? _theme_customized_radius_buttons : '20px';
}, function(param) {
    var theme = param.theme;
    var _theme_customized_textTransforms, _theme_customized;
    var _theme_customized_textTransforms_buttons;
    return (_theme_customized_textTransforms_buttons = theme === null || theme === void 0 ? void 0 : (_theme_customized = theme.customized) === null || _theme_customized === void 0 ? void 0 : (_theme_customized_textTransforms = _theme_customized.textTransforms) === null || _theme_customized_textTransforms === void 0 ? void 0 : _theme_customized_textTransforms.buttons) !== null && _theme_customized_textTransforms_buttons !== void 0 ? _theme_customized_textTransforms_buttons : 'uppercase';
});
var ActionsContainer = styled.div(_templateObject1());
var Title = styled.p(_templateObject2());
var TextContainer = styled.div(_templateObject3());
var AspectRatioOuter = styled.div(_templateObject7(), function(param) {
    var $isUsingGapSpacing = param.$isUsingGapSpacing;
    return $isUsingGapSpacing && css(_templateObject4());
}, function(param) {
    var className = param.className, isSingularCard = param.isSingularCard;
    return /* single card offers can stretch full width up to 600 */ _.includes(className, "offers") && isSingularCard && "\n      min-width: unset;\n      margin-right: 25px;\n    ";
}, function(param) {
    var $isUsingGapSpacing = param.$isUsingGapSpacing;
    return $isUsingGapSpacing && css(_templateObject5());
}, function(param) {
    var enableRightMargin = param.enableRightMargin;
    return enableRightMargin ? "-14px" : 0;
}, function(param) {
    var $isUsingGapSpacing = param.$isUsingGapSpacing;
    return $isUsingGapSpacing && css(_templateObject6());
}, function(param) {
    var enableRightMargin = param.enableRightMargin;
    return enableRightMargin ? "-27px" : 0;
});
var AspectRatioInner = styled.div(_templateObject8());
var OffersCardContainer = styled.div(_templateObject9(), function(param) {
    var imageUrl = param.imageUrl;
    return "linear-gradient(180deg, rgba(11, 31, 50, 0.432) 33.75%, rgba(11, 31, 50, 0.9) 100%), url(".concat(imageUrl, ")");
}, function(param) {
    var theme = param.theme;
    var _theme_customized_radius_cards;
    return (_theme_customized_radius_cards = theme.customized.radius.cards) !== null && _theme_customized_radius_cards !== void 0 ? _theme_customized_radius_cards : '20px';
});
export default OffersCarouselCard;
